import { Page } from '@/components';
import { useParams } from 'react-router';
import TopKpis from './TopKpis';
import HistoricTabs from './HistoricTabs';
import { ActivityCard } from '@/components';
import { Flex, Heading, WalletAddress } from '@blockanalitica/ui';
import SupplyPositionsCardList from './SupplyPositionsCardList';
import BorrowPositionsCardList from './BorrowPositionsCardList';

export default function WalletPage() {
  const { walletAddress, network } = useParams() as {
    walletAddress: string;
    network: string;
  };
  return (
    <Page
      title={
        <WalletAddress
          gap="s"
          options={{
            showCopyBtn: true,
            showEthScanLink: true,
            showDebankLink: true,
            sizes: {
              icon: '8',
              walletAddressHeader: '4'
            },
            network: network
          }}
          address={walletAddress}
        />
      }>
      <TopKpis />
      <HistoricTabs walletAddress={walletAddress} />
      <Heading size="3">Positions</Heading>
      <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
        <SupplyPositionsCardList />

        <BorrowPositionsCardList />
      </Flex>
      <ActivityCard
        url={`/wallets/${walletAddress}/heatmap/`}
        linkTo="activity"
        onClickUrl={`activity`}
      />
    </Page>
  );
}
